import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import React from 'react';
import './loading-panel.scss';

// mute lint warnings as we're memoising this component so can't assign defaults
interface LoadingPanelProps {
  size?: number;
  loadingMessage?: string;
}

const LoadingPanel = React.memo(
  ({ size = 50, loadingMessage = undefined }: LoadingPanelProps) => (
    <Box data-testid="loading-panel" className="loading-spinner">
      <Stack alignItems="center" spacing={1}>
        <CircularProgress size={size} />
        {loadingMessage && <Typography>{loadingMessage}</Typography>}
      </Stack>
    </Box>
  )
);

export default LoadingPanel;
